import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Menu } from './Menu';

@Component({
    selector: 'app-menu',
    templateUrl: './MenuComponent.html',
    standalone: false
})
export class MenuComponent {
	@Input()
	menu: Menu;
	@Input()
	activeItemClass: string;
	@Input()
	itemClass: string;
	@Input()
	caret = false;

}
